import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const EditImageModal = ({ image, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: ''
  });

  const categoryOptions = [
    { value: 'wedding', label: 'تصوير حفلات الزفاف' },
    { value: 'portrait', label: 'التصوير الشخصي' },
    { value: 'event', label: 'تصوير المناسبات' },
    { value: 'real-estate', label: 'تصوير العقارات' },
    { value: 'food', label: 'تصوير الطعام' },
    { value: 'product', label: 'تصوير المنتجات' },
  ];

  useEffect(() => {
    if (image) {
      setFormData({
        title: image?.title,
        category: image?.category
      });
    }
  }, [image]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({ ...image, ...formData });
  };

  if (!image) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[2000] p-4">
      <div className="bg-card rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-warm-xl">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
            تعديل تفاصيل الصورة
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth"
            aria-label="إغلاق"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6">
          <div className="mb-6">
            <div className="aspect-video bg-muted rounded-xl overflow-hidden">
              <img
                src={image?.url}
                alt={image?.alt}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="space-y-4">
            <Select
              label="الفئة"
              options={categoryOptions}
              value={formData?.category}
              onChange={(value) => setFormData({ ...formData, category: value })}
              placeholder="اختر الفئة"
              required
            />
          </div>

          <div className="flex items-center gap-3 mt-6 pt-6 border-t border-border">
            <Button
              type="submit"
              variant="default"
              iconName="Save"
              iconPosition="right"
              fullWidth
            >
              حفظ التغييرات
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
            >
              إلغاء
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditImageModal;